
import React, { useEffect } from 'react'
import Spinwheel from '../../common/Spinwheel'
import Attachment from '../../common/Attachment'
import { ImageUrl } from '../../../utils/BaseUrl'
import { uploadImage } from '../../../utils/ApiEndpointFunctions'
import toast from 'react-hot-toast'

function UpdateFormStatusModal({ modalId, formik, loading, handlefile }) {
 
  return (
    <>
      <div className="modal fade" id={modalId} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button type="button" className="btn-close block-close" data-bs-dismiss="modal" aria-label="Close" ></button>
            </div>
            <div className="modal-body block-user">
              <form action="" className="text-start" onSubmit={formik.handleSubmit} >

               <div className='mb-2'>
                  <label htmlFor="limit" className="form-label">Message limit</label>
                  <select name="status" id="modal" className="form-select border border-1" value={formik?.values?.status} onChange={formik?.handleChange}  >
                    <option value="">Choose status</option>
                    <option value="Submitted">Submitted</option>
                    <option value="In-Review"> In-Review</option>
                    <option value="Applied">Applied</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Accepted">Accepted</option>
                    <option value="Issued">Issued</option>
                    <option value="In-person required">In-person required</option>
                  </select>
               </div>


                {formik?.values?.status === "Issued" && <div className='row'>
                  <div className='col-9'>
                    <Attachment 
                    formik={formik} 
                      docSpin={loading} 
                      feildName={formik?.values?.file} 
                    handlefile={(e) => { handlefile(e, formik, "file") }} 
                    />
                    {formik?.touched?.file  && formik?.errors?.file  ? (<div className='req-error'>{formik?.errors?.file }</div>) : null}
                  </div>
                  <div className='col-3' style={{ height: "90px" }}>
                    <a href={formik?.values?.file ? ImageUrl + formik?.values?.file  : "/images/person-circle.svg"} className='me-2 ms-2' target="_blank" rel="noopener noreferrer">
                      <img
                        src={formik?.values?.file  ? ImageUrl + formik?.values?.file  : "/images/person-circle.svg"}
                        alt='file'
                        style={{
                          height: '100%',
                          width: "100%",
                          cursor: 'pointer',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                        }}
                      />
                    </a>
                  </div>
                </div>}
                
                <div className="modal-footer justify-content-center ">
                  <button type="submit" className="btn-custom w-auto mt-2" disabled={loading} onClick={() => { }} >
                    {loading ? <Spinwheel /> : "Save"}
                  </button>
                  <button type="button" className="btn-custom w-auto mt-2" data-bs-dismiss='modal' >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UpdateFormStatusModal